export default __webpack_public_path__ + "static/media/namaste.77f9d88f.png";